import { useCallback, useMemo } from 'react';

import { communicationTypeLabels } from '../../../lib/helpers/communication.helpers';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { SportTerminology } from '../../../lib/types';

// Resolves a communication's template type to its display label, with the association's
// sport terminology applied. Shared by every surface that lists communications.
export const useCommunicationTypeLabel = () => {
  const termLookup = useCompanySportTerminology()
  const sessionTerm = termLookup[SportTerminology.SESSION];

  const labels = useMemo(() => communicationTypeLabels(sessionTerm), [sessionTerm]);

  // A type the backend sends before this table catches up renders its raw wire value,
  // never a blank row.
  return useCallback((type: string) => labels[type as CommunicationType] || type, [labels]);
};
